
import React, { useState } from "react";
import { hideDiv, showDiv } from '../../../utility/utility';
import { useDispatch, useSelector } from "react-redux";
import { updateApplication } from "../../../store/reducers/applicationSlice";
import { createNotification } from "../../../store/reducers/notificationSlice";



const DescripanciesBox = ({ descrepancies, setCurrentPage, currentPage, setSelectedFieldData, selectedFieldData, formId, applicationState, userId, applicationName }) => {
    const dispatch = useDispatch();
    const [currentFieldSelected, setCurrentFieldSelected] = useState("null");
    const user = useSelector((state) => state.auth.user);
    const authToken = user.access_token;


    const handleAddDiscrepancy = async () => {
        const currentTime = new Date().toLocaleTimeString();
        console.log('Updating discrepancies with data:', selectedFieldData); // Debug log

        const payload = {
            token: authToken,
            id: formId,
            currentTime,
            descripencie: selectedFieldData,  // Using the parameter name expected by the API
        };

        console.log('Full payload being sent:', payload); // Debug log

        await dispatch(updateApplication(payload));

        // dispatch(createNotification({
        //     user_id: userId || user.user.id,
        //     applicationId: formId,
        //     applicationName: applicationName,
        //     status: "Discrepancies Updated",
        //     accessToken: authToken,
        //     sendToCompanyAdmins: true,
        //     companyName: user.user?.company_name,
        //     employeeName: applicationName // It is passed as applicationName in this component
        // }))
    };


    const handleInputChange = (id, value) => {
        setSelectedFieldData(prevFields => {
            // Create a new object for the updated field
            const updatedField = {
                ...prevFields[id],
                value: value
            };

            // Return a new state object
            return {
                ...prevFields,
                [id]: updatedField
            };
        });
    }


    const inputBoxClicked = (id) => {
        if (currentFieldSelected !== id) {
            if (currentFieldSelected !== "null") {
                const currentFieldSelectedElement = document.getElementById(currentFieldSelected.replace("dis_", ""));
                currentFieldSelectedElement.style.backgroundColor = '';

            }
            setCurrentFieldSelected(id);
            id = id.replace("dis_", "");
            const temp = id.split('_');
            const pageId = temp[temp.length - 1];
            if (currentPage !== pageId) {
                hideDiv(currentPage)
                showDiv(pageId)
                setCurrentPage(pageId);
            }
            const element = document.getElementById(id);
            if (element) {
                element.style.backgroundColor = '#ff0000'; // Change background color to red
            }


        } else {
            id = id.replace("dis_", "");
            const element = document.getElementById(id);
            if (element) {
                element.style.backgroundColor = ''; // Change background color to red
            }
            setCurrentFieldSelected("null");
        }

    }




    return (
        <div className="discontainer">
            <div className='title'>Discrepancies</div>
            <div className='disform'>
                <div className='boardHeadRight'>
                    <div className='boardFilter'>
                        {Object.entries(selectedFieldData).map(([id, data]) => (
                            <div className="form-check form-check-inline d-flex gap-1 align-items-center" key={id}>
                                {user?.user?.user_role === 'company_admin' && applicationState !== 'descrepency_GB_Company' ? (
                                    <input
                                        id={`checkbox_${id}`}
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={data.check}
                                        onChange={() => {
                                            if (user?.user?.user_role !== 'employee') {
                                                setSelectedFieldData(prev => {
                                                    const newData = { ...prev };
                                                    if (newData[id]) {
                                                        delete newData[id];
                                                        // Remove red background from form field
                                                        const formField = document.getElementById(id.replace('dis_', ''));
                                                        if (formField) {
                                                            formField.style.backgroundColor = '';
                                                        }
                                                    }
                                                    return newData;
                                                });
                                            }
                                        }}
                                        readOnly={user?.user?.user_role === 'employee' ? true : false}
                                    />
                                ) : null}
                                <textarea
                                    id={id + "_text"}
                                    placeholder="Enter discrepancy description"
                                    value={data.value || ''}
                                    onChange={(e) => handleInputChange(id, e.target.value)}
                                    ref={(el) => {
                                        if (el) {
                                            el.style.height = "auto";
                                            el.style.height = el.scrollHeight + "px";
                                        }
                                    }}
                                    className="form-check-label"
                                    style={{
                                        flex: 1,
                                        resize: "none",
                                        overflow: "hidden",
                                        minHeight: "38px",
                                        padding: "6px 12px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px"
                                    }}
                                    rows={1}
                                    readOnly={user?.user?.user_role === 'employee' || applicationState === 'descrepency_GB_Company' ? true : false}
                                />
                                <div onClick={() => { inputBoxClicked(id) }
                                }>
                                    <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z" /></svg>
                                </div>
                                {/* <label style={{ marginLeft: '8px', fontSize: '12px', color: '#666' }}>
                                    Field: {id.replace('dis_', '')}
                                </label> */}
                            </div>
                        ))}
                        {user?.user?.user_role === 'company_admin' && applicationState === 'application_sent_to_discrepancy_by_company' ? (
                            <div style={{ padding: '20px 0', textAlign: 'center', color: '#666', fontSize: '14px', marginBottom: '50px' }}>
                                Click on form fields to add discrepancies
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            {user?.user?.user_role === 'company_admin' && applicationState === 'application_sent_to_discrepancy_by_company' ? (
                <div className="buttonGroup">
                    <button className="AppFormButton" onClick={handleAddDiscrepancy}>Update Discrepancies</button>
                </div>
            ) : null}


        </div>
    );
};


export default DescripanciesBox;